import { refreshDefaultChartStyle } from '@/composables/refreshDefaultChartStyle';
import { hasDefaultChartStyleBeenInitialized } from '@/composables/hasDefaultChartStyleBeenInitialized';

export async function initializeDefaultChartStyle() {
  if (hasDefaultChartStyleBeenInitialized()) {
    return;
  }

  await refreshDefaultChartStyle();
}
